import axios from 'axios';
import { IDatabase } from '../../database';
import { rootGizmoDataV2ToV3, rootGizmoDataV3ToV2 } from '../../gizmos/utils';
import {
  IRealmFilledForm,
  IRootGizmoData,
  IUserV2,
  TOfflineStatus,
} from '../../types';

interface IParams {
  rootGizmoData: IRootGizmoData[];
  publicRG?: boolean;
  context: {
    apiUrl: string;
    user?: IUserV2;
    database?: IDatabase;
  };
}

/**
 * Save root gizmo data on the server
 *
 * @param {IRootGizmoData[]} rootGizmoData data we're going to save on the server
 *
 * @returns {IRootGizmoData[]} updated root gizmo data
 */
function saveRootGizmoData({
  rootGizmoData,
  publicRG,
  context,
}: IParams): Promise<IRootGizmoData[]> {
  return new Promise<IRootGizmoData[]>(async resolve => {
    const { apiUrl, user, database } = context;
    let savedRootGizmoData: IRootGizmoData[] = [];
    let url: string | undefined;
    let headers = {};

    if (user?.credentials) {
      const credentials: any = user.credentials;
      url = `${apiUrl}/main_api/v1/root_gizmo/data/`;
      if (publicRG) {
        url = `${apiUrl}/main_api/v1/public/root_gizmo/data/`;
      }

      headers = {
        ...credentials,
      };
    } else if (publicRG) {
      url = `${apiUrl}/main_api/v1/public/root_gizmo/data/`;
    }

    if (url && !database) {
      const saveRootGizmoDataResponse = await axios.post(
        url,
        {
          registers: rootGizmoData.map(r => rootGizmoDataV3ToV2({ data: r })),
        },
        {
          headers,
        }
      );

      if (saveRootGizmoDataResponse.status === 200) {
        const savedRegisters =
          saveRootGizmoDataResponse.data['saved_registers'];

        if (
          savedRegisters &&
          Array.isArray(savedRegisters) &&
          savedRegisters.length > 0
        ) {
          savedRootGizmoData = savedRootGizmoData.concat(
            savedRegisters.map(r => rootGizmoDataV2ToV3({ data: r }))
          );
        }
      }
    } else if (database) {
      for (const rgd of rootGizmoData) {
        let offlineStatus: TOfflineStatus | undefined;

        try {
          const savedFilledForm: IRealmFilledForm = await database.get({
            type: 'filledForms',
            fid: rgd.fid,
          });
          offlineStatus = savedFilledForm.offlineStatus;
        } catch (e) {}

        if (offlineStatus) {
          rgd.offlineStatus = offlineStatus;
        }

        await database.set({
          type: 'filledForms',
          value: rootGizmoDataV3ToV2({ data: rgd }),
          update: true,
        });
      }
    }

    resolve(savedRootGizmoData);
  });
}

export default saveRootGizmoData;
